import { render, staticRenderFns } from "./asignar-usuarios.vue?vue&type=template&id=461e7bf1"
import script from "./asignar-usuarios.vue?vue&type=script&lang=js"
export * from "./asignar-usuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports